import styled from '@emotion/styled'
import { ApiSavedPortfolio } from 'api/rtk-api'

import { Space } from '@/components/core-v2'

import { PortfolioSearchFilter } from '../../state/edit-portfolio-slice'
import PortfoliosView from '../../templates/portfolios-view'
import { PortfolioPanelHeader } from './portfolio-panel-header'

export enum FilterFofPortfolioStatus {
  ALL = 'All',
  ACTIVE = 'Active',
  INACTIVE = 'Inactive'
}

export type PortfoliosPanelProps = {
  canUserStartNew: boolean
  onSearch: (filter: PortfolioSearchFilter) => void
  onSelectNewPortfolio: () => void
  onSelectPortfolio?: (portfolioId: string) => void
  portfolios: ApiSavedPortfolio[]
  searchFilter: PortfolioSearchFilter
  selectedPortfolio?: ApiSavedPortfolio
}

const StyledList = styled.div`
  border-top: solid 1px var(--White90);
  height: calc(100vh - 380px);
  overflow-y: auto;
`

export const PortfoliosPanel = ({
  canUserStartNew,
  onSearch,
  onSelectNewPortfolio,
  onSelectPortfolio,
  portfolios,
  searchFilter,
  selectedPortfolio
}: PortfoliosPanelProps) => (
  <Space isflex flexDirection="column">
    <PortfolioPanelHeader
      canUserStartNew={canUserStartNew}
      portfolios={portfolios}
      searchFilter={searchFilter}
      onSearch={onSearch}
      onSelectNewPortfolio={onSelectNewPortfolio}
    />
    <StyledList>
      <PortfoliosView
        portfolios={portfolios}
        selectedPortfolio={selectedPortfolio}
        onSelectPortfolio={onSelectPortfolio}
      />
    </StyledList>
  </Space>
)
